module.exports = __webpack_public_path__ + "static/media/recommends_03_role_specific.77d18bc8.png";